export const appPath = "";

export const chilPath = {
  signin: "sign-in",
  signup: "sign-up",
  verifyOTP: "verify-otp",
  userInfo: "user-info",
  orderConfirm: "order-confirmation",
  successOrder: "success-order",
  loginOtp: "login-otp",
  register: "customer-info",
  customerInforSuccess: "customer-infor-success",
  CustomerInforQrcode: "customer-infor-qrcode",
  CustomerConfirmReceiveGift: "customer-confirm-receive-gift",
  customerInforSave: "customer-infor-save",
  loginPhoneSkipVerify: "login-phone-skip-verify",
  giftList: "gift-list",
  stock: "uhub-stock",

  giftReport: "gift-report",
  storeReport: "store-report",
  customerLuckyGiftSuccess: "gift-success",
  sendGiftSuccess: "send-gift-success",
  shopperLuckyGiftSuccess: "shopper-lucky-gift-success",
  luckyAndCreate: "lucky-and-create",
  luckyTwice: "lucky-twice",
  luckyTwiceSuccess: "lucky-twice-success",
  shopperLuckyGiftError: "shopper-not-found",
  luckyAftergivegiftSmsconfirm: "lucky-after-givegift-smsconfirm",
  giveGiftMechanic: "give-gift-mechanic",
  surveyList: "survey-list",
  surveyUser: "survey",
  giveGiftSkipPii: "give-gift-skip-pii",
  giveGiftSkipPiiSuccess: "give-gift-skip-pii-success",
  collectDataSuccess: "collect-success",
};

export const ugiftPath = {
  sampUnauth: {
    path: "unauth-samp/",
    child: {
      shopperInfo: {
        path: "unauth-samp/",
      },
      shopperHome: {
        path: "unauth-samp/home",
      },
      invoiceDetail: {
        path: "unauth-samp/invoice",
      },
      samp: {
        path: "unauth-samp/samp/",
      },
      success: {
        path: "unauth-samp/success",
      },
      verifyOTP: {
        path: "unauth-samp/verify_otp",
      },
    },
  },
  browser: {
    route: "browser",
    path: "browser",
  },
  browserIphone: {
    route: "browser-iphone",
    path: "browser-iphone",
  },
  browserAndroid: {
    route: "browser-android",
    path: "browser-android",
  },
};

export const menuHome = {
  title: "Home",
  path: appPath + "home",
  icon: "",
};

export const menuHomeKnorr = {
  title: "Knorr",
  path: appPath + "knorr",
  icon: "",
};
export const menuLoginPhone = {
  title: "ĝăng nhập/ đăng ký",
  path: appPath + "login-phone",
  icon: "",
};

export const menuShopperConfirm = {
  title: "Shopper Confirm",
  path: appPath + "shopper",
  icon: "",
};

export const menuGiftStore = {
  title: "Quản lý kho quà",
  path: appPath + "gift-store",
  icon: "",
};

export const menuRegister = {
  title: "ĝăng ký",
  path: appPath + "login-phone" + "register",
  icon: "",
};

export const menuLoginOtp = {
  title: "Xác thực OTP",
  path: appPath + "login-phone" + "login-otp",
  icon: "",
};

export const menuCustomerLucky = {
  title: "Quay quà may mắn",
  path: appPath + "customer-lucky",
  icon: "",
};

export const menuGiveGift = {
  title: "Tặng quà",
  path: appPath + "send-gift",
  icon: "",
};

export const menuReport = {
  title: "Tặng quà",
  path: appPath + "export-report",
  icon: "",
};

export const menuListPurchase = {
  title: "menuListPurchase",
  path: appPath + "list-purchase",
  icon: "",
};

export const menuListMechanic = {
  title: "menuListMechanic",
  path: appPath + "list-mechanic",
  icon: "",
};

export const menuInvoice = {
  title: "menuInvoice",
  path: appPath + "invoice-ocr",
  icon: "",
};

export const menuOcrSuccess = {
  title: "menuOcrSuccess",
  path: appPath + "invoice-success",
  icon: "",
};

export const menuBanker = {
  title: "Banker",
  path: appPath + "manual-banker",
  icon: "",
};

export const menuSkuCheck = {
  title: "Banker",
  path: appPath + "sku-check",
  icon: "",
};

export const menuDevice = {
  title: "device",
  path: appPath + "device",
  icon: "",
};

export const qrLoginMenu = {
  title: "QR Login",
  path: appPath + "fast-login",
  icon: "",
};

export const physicalGift = {
  title: "Physical gift",
  path: appPath + "phys",
  icon: "",
};

export const checkFP = {
  title: "Check FP",
  path: appPath + "check-fp",
  icon: "",
};

export const loyaltyGift = {
  title: "Loyalty gift",
  path: appPath + "loyalty",
  icon: "",
};

export const menuCreateGiveGiftTicket = {
  title: "Thông tin phiếu nhận quà",
  path: appPath + "create-give-gift-ticket",
  icon: "",
};

export const Config = {
  menu: [menuHome, menuGiftStore],

  registerMenu: [menuHome],
  utopApiPath: {
    requestOTP: "auth/SmsOtp/RequestOtp",
    verifyOTP: "auth/SmsOtp/VerifyOtp",
    getUserInfo: "point/GetUserInfo",
    updateUserInfo: "point/UpdateUserInfo",
    isPhoneRegisted: "point/CheckPhoneNumber",
    requestLogin: "point/RequestLogin",
    products: "cms/core/products",
    productDetail: "cms/core/product",
    smsLog: "Logger/SmsLog",
    logger: "Logger/Logger",
    registDevice: "Master/RegistDevice",
    otpLog: "Logger/OTPLog",
    insightLogging: "insight/logging",
  },

  unileverApiPath: {
    login: "User/Authenticate",
    logout: "User/Logout",
    refresh: "User/Refresh",
    getCampaignbyStaff: "User/GetCampaignByStaff",
    requestLogin: "auth/RequestLogin",
    qrlink: "auth/Qrlink",
    checkPhoneRegistered: "ugift/Member/CheckPhoneNumber",
    getUserByPhone: "Member/GetUserByPhone",
    UpdateProduct: "Product/UpdateProduct",
    getProductsByStaff: "Product/GetProductsByStaff",
    getProductsByConfig: "Product/GetProductsByConfig",
    getCurrentMaxGift: "Product/GetCurrentMaxGift",
    getTransactionInfo: "Product/GetTransactionDetail",
    randomGift: "Product/Draw",
    unAuthRedemp: "Product/RedemGift",
    getMechanicProductsByStaff: "Product/GetMechanicProductsByStaff",
    createOrder: "Product/CreateOrder",
    createPostOrder: "Product/CreatePosOrder",
    UploadImage: "User/UploadImage",
    getProductReport: "Product/GetProductReport",
    getProductReportByStore: "Product/GetProductReportByStore",
    getMasterByCode: "Master/GetMasterByCode",
    getAgeRange: "ugift/AgeRange",
    getSettingByKey: "Master/GetSettingByKey",
    downloadProductReport: "Product/DownloadProductReport",
    checkProductsByStaff: "Product/checkProductsByStaff",
    getRandomGift: "Product/RandomGift",
    getRandomGift2: "Product/RandomGiftAndCreateOrder",
    getTurnBalance: "Member/GetTurnBalance",
    getLocation: "Master/GetLocation",
    getOrderShopper: "Product/GetOrderShopper",
    confirmOrder: "Product/ConfirmOrder",
    unauthConfirmOrder: "Product/UnauthConfirmOrder",
    adminProduct: "Product/GetProductAdmin",
    adminProductByMechanic: "Product/GetProductAdminByMechanic",
    createInvoice: "Invoice/CreateInvoice",
    invoiceOcr: "Invoice/InvoiceOCR",
    getMall: "Master/GetMall",
    getStore: "Master/GetStoreByMall",
    getMallByCampaign: "Master/GetMallByCampaign",
    getStoreBycampaign: "Master/GetStoreByMallCampaign",
    getTopUIConfig: "Master/GetTopUIConfig",
    updateInvoice: "Invoice/UpdateInvoice",
    getCampaignConfig: "User/GetCampaignConfig",
    getExtraGiftByadminProduct: "Product/GetExtraGiftByadminProduct",
    getUserInfo: "auth/UserInfo",
    updateUserInfo: "auth/UpdateInfo",
    updateTurnBalance: "Product/UpdateTurnBalance",
    getInvoiceDetail: "Invoice/GetInvoiceDetail",
    getLuckyMechanicGift: "Product/GetLuckyGiftByMechanic",
    getCampaignSku: "Product/GetCampaignSku",
    checkSku: "Product/CheckSku",
    getRemainTimeConfirm: "Product/GetRemainConfirmTime",
    getRemainTimeConfirmByCode: "Product/GetRemainConfirmTimeByCode",
    requestQrLogin: "Member/LoginWithQrCode",
    requestQrLoginSkipUserInfo: "Member/LoginWithQrCodeFlowSkipUserInfo",
    createUnAuthUser: "Member/CreateUnAuthUser",
    checkStoreCode: "User/CheckStoreCode",

    getPhysicalCodeContent: "Code/GetCodeContent",
    confirmPhysicalGift: "Code/ConfirmGift",
    updateStock: "Stock/UpdateStock",
    updateStoreStatus: "Setting/SwitchStoreStatus",
    getUhubProduct: "Product/GetUhubProduct",
    getStoreStatus: "Setting/GetStoreStatus",
    getProductAutoComplete: "Product/GetAutoCompleteSku",
    getValidMechanicGift: "Product/GetValidMechanicGift",
    createMechanicRedemption: "MechanicRedem/CreateOrder",

    getMallGiftLoyaty: "GiftLoyaltyControler/GetMall",
    getStoreGiftLoyaty: "GiftLoyaltyControler/GetStore",
    getCampaignLoyalty: "GiftLoyaltyControler/GetCampaign",
    getGiftOfCustommerLoyalty: "GiftLoyaltyControler/GetGift",
    getCustommerBytoken: "GiftLoyaltyControler/GetCustomer",
    updateOrderDetailLoyalty: "GiftLoyaltyControler/UpdateStatusOderDetail",
    checkOTPByUserId: "GiftLoyaltyControler/CheckOTP",

    //Mechanic List campaign
    getMechanicListConfig: "User/GetMechanicListConfig",
    getMechanicList: "Mechanic/GetMechanicList",
    getProductsByMechanic: "Mechanic/GetProductsByMechanic",

    //Survey
    getListCamPaignSettingsByCampaignId:
      "api/CampaignAdmin/GetListCamPaignSettingsByCampaignId",
    getSurveyByCampaign: "Survey/GetSurveyByCampaign",
    insertSurveyResult: "Survey/InsertSurveyResult",
    getQuestionByArticle: "Survey/GetQuestionByArticle",
    getAnswerByUserAndCampaign: "Survey/GetAnswerByUserAndCampaign",
    submitSurvey: "Survey/SubmitSurvey",
    ugiftSubmitSurvey: "ugift/submitsurvey",
    updateSurvey: "Survey/UpdateSurvey",

    // province
    getProvince: "Province/GetProvince",
    getDistrict: "Province/GetDistrict",
    getCommune: "Province/GetCommune",

    //Give gift ticket
    saveGiveGiftTicket: "Pos/SaveGiveGiftTicket",
    getEditTicketCounter: "Pos/GetEditTicketCounter",

    // Location
    getCampaignLocations: "Location/GetCampaignLocations",

    // Gigya
    gigya: {
      request: "Gigya/GigyaRequest",
    },

    //renew token
    reNewToken: "auth/refreshtoken",

    campaignInfo: "loyalty/api/Campaign/GetCampaignInfo",
  },
  cameraResolution: {
    width: { ideal: 720 },
    height: { ideal: 2048 },
    aspectRatio: { ideal: 1.5 },
  },
};
